import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { getSubscriptionRedirectUrl, getCurrencyUsedInCB, convertPlanIdIntoSubscription } from '../../utils/subscription';
import { NextIcon, XDarkLogo, XaraLogo } from '../../theme/icons';
import { getRoute, SUBSCRIPTION, SUBSCRIPTION_PLUS_OVERVIEW, SUBSCRIPTION_PERPETUAL_OVERVIEW } from 'routes';
import { bindActionCreators } from 'redux';
import { changeCompanyAndNotify, resolveActiveCompanyId } from 'redux/modules/companies';
import { showModal } from 'redux/modules/modal';
import {
	trackWrongAccountScreen,
	trackWrongAccountScreenUseExistingAccount,
	trackWrongAccountScreenSwitchAccount
} from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import { 
	XC_URL,
	SKIP_ONBOARDING_PARAM,
	BACK_TO_PARAM,
	APP_COMPANY_ID_PARAM,
	PRODUCT_NAME_PARAM,
	PRODUCT_QUANTITY_PARAM,
	PRODUCT_LANGUAGE_PARAM,	
	USER_ROLE_ADMIN,
	USER_ROLE_BASIC,
	MAGIX_EMAIL_PARAM,
	MAGIX_SERIAL_PARAM,
	MAGIX_CATEGORY_PARAM,
	COUPON_ID_PARAM,
	UPGRADE_POPUP_PARAM,
	EXTERNAL_REDIRECT_PARAM,
	INTERNAL_REDIRECT_PARAM,
	PRODUCT_SOURCE_PARAM,
	PERIOD_PARAM
} from '../../config';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import {
	Link,
	List,
	ListItem,
	ListItemIcon,
	ListItemText
} from '@material-ui/core';

const localize = i18n.loc.localize;

const styles = theme => ({
	wrongAccount: {
		textAlign: 'center',
		margin: '4rem'
	},
	wrongAccountTitle: {
		margin: '3rem 0 4.7rem',
		fontWeight: 'bold'
	},
	xDarkLogo: {
		width: '57px',
		height: '57px',
		display: 'inline',
		position: 'relative',
		top: '10px'
	},
	xaraLogo: {
		width: '85px',
		height: '30px',
		display: 'inline',
		color: theme.palette.colors.alpha
	},
	currentlySignedInTitle: {
		fontSize: '22px',
		lineHeight: '32px',
		fontWeight: 'bold',
		color: '#2E3F4F'
	},
	currentlySignedInEmail: {
		margin: '1.5rem 0 2rem',
		fontWeight: 'bold'
	},
	list: {
		display: 'inline-block'
	},
	listItem: {
		marginBottom: '10px',
		'&:hover button, &:hover a': {
			textDecoration: 'none',
			color: theme.palette.colors.zeta
		},
		'&:hover svg': {
			color: theme.palette.colors.zeta
		}		
	},
	listItemIcon: {
		margin: '0 10px 0 0'
	},
	listItemText: {
		padding: 0
	},
	nextIcon: {
		width: '16px',
		height: '16px',		
		color: theme.palette.colors.alpha,
		position: 'relative',
		top: '1px'
	},
	listItemLink: {	
		fontSize: '18px',
		lineHeight: '23px',
		fontWeight: 'bold'
	}
});

@withStyles(styles)
class WrongAccount extends Component {

	componentDidMount() {
		trackWrongAccountScreen(getTrackingOptions(this.props.company));
	}

	renderUpgradePopup(
		planId,
		currency,
		productName,
		productLang,
		magixSerial,
		magixEmail,
		magixCat,
		couponId,
		isUpgradePopup,
		isCBPlanExternalRedirect,
		isCBPlanInternalRedirect,
		productQuantity,
		productPeriod,
		productSource) {

		if (planId) {
			this.props.showModal('UPGRADE_COMPANY_MODAL', 
			{ 
				planId,
				currency,
				productName,
				productLang,
				magixSerial,
				magixEmail,
				magixCat,
				couponId,
				isUpgradePopup,
				isCBPlanExternalRedirect,
				isCBPlanInternalRedirect,
				productQuantity,
				productPeriod,
				productSource
			});
		}
	}

	renderCompanySelectionPopup(redirectURL) {
		this.props.showModal('COMPANY_SELECTION_MODAL', { redirectURL });
	}

	render() {
		const { classes, companies, currentUserEmail } = this.props;
		const { rawDataById } = companies;
		const sessionCompanyId = resolveActiveCompanyId(false);
		const sessionCompany = companies.rawDataById[sessionCompanyId];
		let prevLocationPath = _.get(this.props, 'location.state.prevLocationPath');
		const prevLocationSearch = _.get(this.props, 'location.state.prevLocationSearch');
		const prevLocationCurrency = _.get(this.props, 'location.state.prevLocationCurrency');
		const prevLocationProductName = _.get(this.props, 'location.state.prevLocationProductName');
		const prevLocationProductQuantity = _.get(this.props, 'location.state.prevLocationProductQuantity');
		const prevLocationProductSource = _.get(this.props, 'location.state.prevLocationProductSource');
		const prevLocationProductPeriod = _.get(this.props, 'location.state.prevLocationProductPeriod');
		const prevLocationProductLanguage = _.get(this.props, 'location.state.prevLocationProductLanguage');
		const prevLocationMagixSerial = _.get(this.props, 'location.state.prevLocationMagixSerial');
		const prevLocationMagixEmail = _.get(this.props, 'location.state.prevLocationMagixEmail');
		const prevLocationMagixCat = _.get(this.props, 'location.state.prevLocationMagixCat');
		const prevLocationCouponId = _.get(this.props, 'location.state.prevLocationCouponId');
		const prevLocationPlanId = _.get(this.props, 'location.state.prevLocationPlanId');
		const isDesktopApp = _.get(this.props, 'location.state.isDesktopApp');
		const prevLocationUpgradePopup = _.get(this.props, 'location.state.prevLocationUpgradePopup');
		const prevLocationIsCBPlanExternalRedirect = _.get(this.props, 'location.state.prevLocationIsCBPlanExternalRedirect');
		const prevLocationIsCBPlanInternalRedirect = _.get(this.props, 'location.state.prevLocationIsCBPlanInternalRedirect');
		const prevCbPlanId = _.get(this.props, 'location.state.prevCbPlanId');

		let queryString = prevLocationSearch && Object.keys(prevLocationSearch).length
			?
			Object.entries(prevLocationSearch).map(([key, val]) => `${key}=${val}`).join('&')
			:
			null;

		COUPON_ID_PARAM;

		if (prevLocationUpgradePopup) {
			queryString = queryString ? `${queryString}&${UPGRADE_POPUP_PARAM}=1` : `${UPGRADE_POPUP_PARAM}=1`;
		}

		if (prevLocationCouponId) {
			queryString = queryString
				?
				`${queryString}&${COUPON_ID_PARAM}=${prevLocationCouponId}`
				:
				`${COUPON_ID_PARAM}=${prevLocationCouponId}`;
		}

		const adminOrMemberOfCompanies = rawDataById
			?
			Object.values(rawDataById)
				.filter(company => [USER_ROLE_ADMIN, USER_ROLE_BASIC].includes(company.userRole))
			:
			[];
		
		return (
			<div className={classes.wrongAccount}>
				<XDarkLogo className={classes.xDarkLogo} />
				<XaraLogo className={classes.xaraLogo} />
				
				<Typography className={classes.wrongAccountTitle} variant="h2">
					{localize('wrong-account-title')}
				</Typography>
				<Typography variant="body2" className={classes.currentlySignedInTitle}>
					{localize('wrong-account-signed-in-title')}
				</Typography>
				<Typography variant="h2" className={classes.currentlySignedInEmail}>
					{currentUserEmail}
				</Typography>
				<List className={classes.list}>
					<ListItem key={'option-use-existing-account'} dense className={classes.listItem}>
						<ListItemIcon className={classes.listItemIcon}>
							<NextIcon className={classes.nextIcon} />
						</ListItemIcon>
						<ListItemText className={classes.listItemText}>
							<Link
								variant="body2"
								data-tid='continue-with-this-account-button'
								className={classes.listItemLink}
								onClick={() => {
									trackWrongAccountScreenUseExistingAccount(getTrackingOptions(this.props.company));
									this.props.changeCompanyAndNotify(sessionCompany);
									
									if (prevLocationPath) {
										// Take currency from existing plan of company in session (as it can't be changed), 
										// otherwise from URL (for plus-overview package), defaults to USD
										let currentPackageCurrency;
										const alreadyUsedCurrency = getCurrencyUsedInCB(sessionCompany);
										alreadyUsedCurrency && (currentPackageCurrency = alreadyUsedCurrency);

										if (queryString && queryString.indexOf('chargebee-plan-id') !== -1 || prevCbPlanId) {
											// eslint-disable-next-line max-len
											// url like http://localhost:3000/#5fa000d8f123/?chargebee-plan-id=plus-overview&currency=usd
											const planId = prevCbPlanId || prevLocationSearch['chargebee-plan-id'];
											//prevCbPlanId

											const currency = currentPackageCurrency || prevLocationCurrency;

											// If user is admin of multiple companies ask user to choose company, 
											// otherwise redirect to URL
											if (adminOrMemberOfCompanies.length > 1) {
												this.renderUpgradePopup(
													planId,
													currency,
													prevLocationProductName,
													prevLocationProductLanguage,
													prevLocationMagixSerial,
													prevLocationMagixEmail,
													prevLocationMagixCat,
													prevLocationCouponId,
													prevLocationUpgradePopup,
													prevLocationIsCBPlanExternalRedirect,
													prevLocationIsCBPlanInternalRedirect,
													prevLocationProductQuantity,
													prevLocationProductPeriod,
													prevLocationProductSource);
											} else {
												const queryVars = ['company-known=1'];

												if (prevLocationProductName) {
													queryVars.push(`${PRODUCT_NAME_PARAM}=${prevLocationProductName}`);
												}
												if (prevLocationProductQuantity) {
													queryVars.push(`${PRODUCT_QUANTITY_PARAM}=${prevLocationProductQuantity}`);
												}
												if (prevLocationProductSource) {
													queryVars.push(`${PRODUCT_SOURCE_PARAM}=${prevLocationProductSource}`);
												}
												if (prevLocationProductPeriod) {
													queryVars.push(`${PERIOD_PARAM}=${prevLocationProductPeriod}`);
												}
												if (prevLocationProductLanguage) {
													queryVars.push(`${PRODUCT_LANGUAGE_PARAM}=${prevLocationProductLanguage}`);
												}
												if (prevLocationMagixSerial) {
													queryVars.push(`${MAGIX_SERIAL_PARAM}=${prevLocationMagixSerial}`);
												}
												if (prevLocationMagixEmail) {
													queryVars.push(`${MAGIX_EMAIL_PARAM}=${prevLocationMagixEmail}`);
												}
												if (prevLocationMagixCat) {
													queryVars.push(`${MAGIX_CATEGORY_PARAM}=${prevLocationMagixCat}`);
												}
												if (prevLocationCouponId) {
													queryVars.push(`${COUPON_ID_PARAM}=${prevLocationCouponId}`);
												}
												if (prevLocationUpgradePopup) {
													queryVars.push(`${UPGRADE_POPUP_PARAM}=${prevLocationUpgradePopup}`);
												}
												if (prevLocationIsCBPlanExternalRedirect) {
													queryVars.push(`${EXTERNAL_REDIRECT_PARAM}=1`);
												}
												if (prevLocationIsCBPlanInternalRedirect) {
													queryVars.push(`${INTERNAL_REDIRECT_PARAM}=1`);
												}
												const redirectURL = getSubscriptionRedirectUrl(
													planId,
													sessionCompanyId,
													currency,
													queryVars
												);

												location.href = redirectURL;
											}

										} else {
											if (prevLocationPath === SUBSCRIPTION_PLUS_OVERVIEW ||
												prevLocationPath === SUBSCRIPTION_PERPETUAL_OVERVIEW) {
												// eslint-disable-next-line max-len
												// url like http://localhost:3000/#63123230879f5c68a6a6c58a0d4/subscription/plus-overview/?desktop-app=1
												prevLocationPath = prevLocationPath.replace(':currency?', '');
												if (prevLocationCurrency) {
													prevLocationPath = `${prevLocationPath}${prevLocationCurrency}`;
												}
											}

											let redirectURL = prevLocationPath;

											if (queryString) {
												redirectURL = `${redirectURL}?${queryString}`;
											}
											
											redirectURL = prevLocationPlanId
												?
												redirectURL.replace(':planId', prevLocationPlanId)
												:
												redirectURL.replace(':planId', '');

											if (adminOrMemberOfCompanies.length > 1) {
												// eslint-disable-next-line max-len
												// url like http://localhost:3000/#64a2a2123123123/subscription/web-annual-usd/?company-known=1
												if (prevLocationPlanId) {
													const relatedSubscription = convertPlanIdIntoSubscription(prevLocationPlanId);
													const planCurrency = relatedSubscription.currency;
													this.renderUpgradePopup(
														prevLocationPlanId,
														planCurrency,
														prevLocationProductName,
														prevLocationProductLanguage,
														prevLocationMagixSerial,
														prevLocationMagixEmail,
														prevLocationMagixCat,
														prevLocationCouponId,
														prevLocationUpgradePopup,
														prevLocationIsCBPlanExternalRedirect,
														prevLocationIsCBPlanInternalRedirect,
														prevLocationProductQuantity,
														prevLocationProductPeriod,
														prevLocationProductSource);
												} else {
													// eslint-disable-next-line max-len
													// url like http://localhost:3000/#64a2a2123123123/subscription/ or http://localhost:3000/#64a2a2123123123/users/
													this.renderCompanySelectionPopup(redirectURL);
												}
											} else {
												this.props.history.push(getRoute(redirectURL, sessionCompanyId));
												window.location.reload();
											}

										}
									} else {
										this.props.history.push(getRoute(SUBSCRIPTION, sessionCompanyId));
										window.location.reload();
									}
								}}
							>
								{localize('wrong-account-use-existing-account')}
							</Link>
						</ListItemText>
					</ListItem>
					<ListItem key={'option-switch-account'} dense className={classes.listItem}>
						<ListItemIcon className={classes.listItemIcon}>
							<NextIcon className={classes.nextIcon} />
						</ListItemIcon>
						<ListItemText className={classes.listItemText}>
						
							<Link
								component="button"
								variant="body2"
								data-tid='change-account-button'
								className={classes.listItemLink}
								onClick={() => {
									trackWrongAccountScreenSwitchAccount(getTrackingOptions(this.props.company));
									let prevComponent;
									if (prevLocationPath) {
										prevComponent = prevLocationPath
											.replace('/:companyId', '')
											.replace(':currency?', '')
											.replace(':planId', '');
									}

									if (!prevComponent || prevComponent.length === 0) {
										prevComponent = '/';
									}

									const urlParams = [
										'switch-account=1',
										`${SKIP_ONBOARDING_PARAM}=1`,
										`${BACK_TO_PARAM}=${encodeURIComponent(prevComponent)}`
									];

									if (prevLocationProductQuantity) {
										urlParams.push(`${PRODUCT_QUANTITY_PARAM}=${prevLocationProductQuantity}`);
									}

									if (isDesktopApp) {
										urlParams.push(`${APP_COMPANY_ID_PARAM}=${sessionCompanyId}`);
									}

									let redirectURL = `${XC_URL}?${urlParams.join('&')}`;

									if (queryString) {
										redirectURL = `${redirectURL}&${queryString}`;
									}

									window.location.href = redirectURL;
								}}
							>
								{localize('wrong-account-change-account')}
							</Link>
						</ListItemText>
					</ListItem>					
				</List>				
			</div>
		);
	}

}

WrongAccount.propTypes = {
	currentUserEmail: PropTypes.string,
	classes: PropTypes.object,
	companies: PropTypes.object,
	company: PropTypes.object,
	changeCompanyAndNotify: PropTypes.func,
	history: PropTypes.object,
	prevLocationCurrency: PropTypes.string,
	prevLocationPlanId: PropTypes.string,
	showModal: PropTypes.func,
	isDesktopApp: PropTypes.bool,
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	})
};

// Leaving Redux bindings for phase 2 of P9052-13492.
const mapStateToProps = state => ({
	companies: state.companies,
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	currentUserEmail: state.session.user.mainEmail,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	changeCompanyAndNotify,
	showModal
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WrongAccount);


// WEBPACK FOOTER //
// ./src/containers/WrongAccount/WrongAccount.js